import { useState, useEffect } from 'react';
import { Filter } from 'bad-words';
import { socket } from "../socket";
import '../stylesheets/Menus.css';
import { trackGameJoinFailed } from "../analytics";

const filter = new Filter();

const JoinGameMenu = ({ onBackClick }) => {
    // used useState to handle input of GameId and Name
    const [formData, setFormData] = useState({ GameId: '', Name: '' });

    useEffect(() => {
        socket.on("serverMessage", (msg) => {
            console.log("Message from server:", msg);
        });

        socket.on("gameJoined", ({ gameId, state }) => {
            console.log("Joined game:", gameId, state);
        });

        socket.on("stateUpdate", ({ state }) => {
            console.log("State update:", state);
        });

        socket.on("error", (err) => {
            console.error("Server error:", err);
            alert(`Error: ${err.message}`);

            trackGameJoinFailed(err.message || "unknown_error");
        });

        return () => {
            socket.off("serverMessage");
            socket.off("gameJoined");
            socket.off("stateUpdate");
            socket.off("error");
        };
    }, []);

    // used to update data
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: name === "GameId" ? value.toUpperCase() : value
        });
    };

    // websocket join game
    const handleJoinClick = (e) => {
        // e.preventDefault();

        const gameId = formData.GameId.trim();
        const name = formData.Name.trim();

        if (!name) {
            alert("Please enter a username.");
            return;
        }

        if (filter.isProfane(name)) {
            alert("Please choose a different username.");
            return;
        }

        if (gameId) {
            socket.emit("joinGame", { gameId, name });
        }
    };

    return (
        <div className="start-menu-container">
            <h1 className="start-menu-title">Call It Out</h1>

            <input
                type="text"
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                placeholder="Username"
                className="join-menu-input"
            />

            <input
                type="text"
                name="GameId"
                value={formData.GameId}
                onChange={handleChange}
                placeholder="Game Id"
                className="join-menu-input"
            />

            <button
                onClick={handleJoinClick}
                className="start-menu-button"
            >
                Join
            </button>

            <button
                onClick={onBackClick}
                className="start-menu-button"
            >
                Back
            </button>
        </div>
    );
};

export default JoinGameMenu;